import React, { useState, useCallback } from 'react'
import { OrderNotification } from '../types/websocket'
import { OrderNotificationToast } from './OrderNotificationToast'

interface NotificationWithId extends OrderNotification {
  id: string
}

export const NotificationContainer: React.FC = () => {
  const [notifications, setNotifications] = useState<NotificationWithId[]>([])
  const recentNotificationsRef = React.useRef<Set<string>>(new Set())

  const addNotification = useCallback((notification: OrderNotification) => {
    // Create unique key for deduplication
    const notificationKey = `${notification.orderId}-${notification.type}-${notification.status}`

    // Check if we already showed this notification in the last 2 seconds
    if (recentNotificationsRef.current.has(notificationKey)) {
      console.log('🚫 Notifica duplicata bloccata:', notificationKey)
      return
    }

    // Add to recent notifications
    recentNotificationsRef.current.add(notificationKey)

    // Remove from recent after 2 seconds
    setTimeout(() => {
      recentNotificationsRef.current.delete(notificationKey)
    }, 2000)

    const notificationWithId: NotificationWithId = {
      ...notification,
      id: `${notification.orderId}-${notification.type}-${Date.now()}`
    }

    console.log('✅ Notifica mostrata:', notificationKey)
    setNotifications((prev) => [...prev, notificationWithId])
  }, [])

  const removeNotification = useCallback((id: string) => {
    setNotifications((prev) => prev.filter((n) => n.id !== id))
  }, [])

  // Expose addNotification globally for the hook to use
  React.useEffect(() => {
    ;(window as any).__addOrderNotification = addNotification
    return () => {
      delete (window as any).__addOrderNotification
    }
  }, [addNotification])

  return (
    <div className="fixed top-4 right-4 z-50 flex flex-col gap-3 max-w-md w-full pointer-events-none">
      <div className="flex flex-col gap-3 pointer-events-auto">
        {notifications.map((notification) => (
          <OrderNotificationToast
            key={notification.id}
            notification={notification}
            onClose={() => removeNotification(notification.id)}
          />
        ))}
      </div>
    </div>
  )
}
